export const PAID_ARTICLE = 'Article payant';
